module.exports = __webpack_public_path__ + "static/media/drippl_logo.7b070acf.png";